
import React, { useState, useEffect, useRef } from 'react';
import { ORG_LEAVE_CONFIGURATIONS, ORG_EXPENSE_OPENING_CRUD } from '../../../../ApiServices/BaseURL';
import { postData, getData } from '../../../../ApiServices/ApiService';
import { useTheme } from '../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../Utils/Exception';

const EmpMgmtSettingsController = () => {
    const { setIsLoginPopup } = useTheme();
    const pageName = "EmploymanagementSettings"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    // useEffect(() => {
    //     handleGetLeaveConfiguration();
    // }, [])
    const [leaveConfigurationsList, setLeaveConfigurationList] = useState([])
    const [leaveConfigurationListLoading, setLeaveConfigurationListLoading] = useState(false)
    const [leaveConfigurationListError, setLeaveConfigurationListError] = useState('')
    const handleGetLeaveConfiguration = async () => {
        try {
            setLeaveConfigurationList([])
            setLeaveConfigurationListError('')

            // Set loading state
            setLeaveConfigurationListLoading(true);

            // Retrieve user information (e.g., emp_id)
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Constructing payload for the API call
            const payload = {
                "action_type": "leave_config_lsit",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            console.log('Payload for Leave Configuration:', payload);
            //   return

            // Make the API call
            const response = await postData(ORG_LEAVE_CONFIGURATIONS, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setLeaveConfigurationList(responseData?.dataJ);
                        console.log("res", responseData?.dataJ)
                        // setTimeout(() => {
                        // clearFields();
                        // setLeaveConfigurationSuccess('')
                        // }, 3000);
                    } else {
                        setLeaveConfigurationListError(responseData?.info || 'Failed to save leave configuration. Please try again.');
                        logFrontendException(storedUserId, pageName, "LeaveConfig", responseData?.info || '');
                    }
                } else {
                    setLeaveConfigurationListError(responseData?.info || 'Failed to save leave configuration. Status code error.');
                    logFrontendException(storedUserId, pageName, "LeaveConfig", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setLeaveConfigurationListError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "LeaveConfig", response || '');
                } else {
                    setLeaveConfigurationListError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "SearchClient", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setLeaveConfigurationListError(responseData?.info || 'Internal Server Error. Please try again later.');
                logFrontendException(storedUserId, pageName, "LeaveConfig", response || '');
            }
            // Unexpected or network-related errors
            else {
                setLeaveConfigurationListError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "LeaveConfig", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setLeaveConfigurationListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to save leave configuration. Please try again.'}`);
                logFrontendException(storedUserId, pageName, "LeaveConfig", error || '');
            } else if (error.request) {
                // Request was made but no response was received
                setLeaveConfigurationListError('No response received from the server. Please check your network connection and try again.');
                logFrontendException(storedUserId, pageName, "LeaveConfig", error || '');
            } else {
                // An error occurred in setting up the request
                setLeaveConfigurationListError(`Failed to save leave configuration. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "LeaveConfig", error || '');
            }
        } finally {
            setLeaveConfigurationListLoading(false);
        }
    };

    useEffect(() => {
        getExpenseOpeningInfo();
    }, [])

    const [expenseOpeningInfo, setExpenseOpeningInfo] = useState(null);
    const [expenseOpeningInfoLoading, setExpenseOpeningInfoLoading] = useState(false);
    const [expenseOpeningInfoError, setExpenseOpeningInfoError] = useState('');

    const getExpenseOpeningInfo = async () => {
        try {
            setExpenseOpeningInfo(null);
            setExpenseOpeningInfoError('')
            setExpenseOpeningInfoLoading(true);

            // Retrieve user information (e.g., emp_id)
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Constructing payload for the API call
            const payload = {
                "action_type": "get_expense_opening_bal_info",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            console.log('Payload for Exp Opening Configuration:', payload);

            // Make the API call
            const response = await postData(ORG_EXPENSE_OPENING_CRUD, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        console.log('responseData', responseData, responseData?.dataJ?.length)
                        if (responseData?.dataJ?.length > 0) {
                            setExpenseOpeningInfo(responseData?.dataJ[0]);
                        } else {
                            // setExpenseOpeningInfoError(responseData?.info || 'No expense management opening balance available.');
                            logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData?.info || '');
                        }
                    } else {
                        setExpenseOpeningInfoError(responseData?.info || 'Failed to get books opening balance.');
                        logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData?.info || '');
                    }
                } else {
                    setExpenseOpeningInfoError(responseData?.info || 'Error while getting books opening balance.');
                    logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setExpenseOpeningInfoError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", responseData || '');
                setIsLoginPopup(true)
            } else {
                setExpenseOpeningInfoError('Failed to get books opening balance. Please try again.');
                logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", response || '');
            }
        } catch (error) {
            setExpenseOpeningInfoError(`Failed to get books opening balance. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "getExpenseOpeningInfo", error || '');
        } finally {
            setExpenseOpeningInfoLoading(false);
        }
    };

    const onExpenseOpeningInfoRefresh = () => {
        getExpenseOpeningInfo();
    }

    return {
        leaveConfigurationListError,
        leaveConfigurationListLoading,
        leaveConfigurationsList,
        handleGetLeaveConfiguration,
        expenseOpeningInfo,
        expenseOpeningInfoLoading,
        expenseOpeningInfoError,
        onExpenseOpeningInfoRefresh
    }
}

export default EmpMgmtSettingsController